/**
 * Enumerates the supported notification categories that can be displayed in the UI.
 *
 * Use these values to standardize visual styling (color, iconography) and
 * accessibility semantics for toast messages, banners, inline alerts, etc.
 *
 * Values:
 * - Success: Indicates an operation completed as intended (e.g., data saved).
 * - Info: Conveys neutral, contextual, or follow‑up information that does not require immediate action.
 * - Error: Signals a failure, blocking issue, or invalid user action that needs attention.
 * - Warning: Highlights a potentially risky or unexpected situation that might require caution or intervention.
 *
 * Recommended usage guidelines:
 * - Prefer Success only for definitive completions (avoid overuse).
 * - Use Info for non‑urgent status updates or background processes.
 * - Reserve Error strictly for actionable problems.
 * - Apply Warning when user awareness can prevent an error or data loss.
 *
 * Example:
 * ```ts
 * this.notificationService.show({
 *   type: NotificationTypeEnum.Success,
 *   message: 'Profile updated successfully.'
 * });
 * ```
 */
export enum NotificationTypeEnum {
  Success = 'success',
  Info = 'info',
  Error = 'error',
  Warning = 'warning',
}
